import React from "react";
import { Button, Typography, IconButton } from "@material-tailwind/react";
import { Upload } from "iconoir-react";

import { Media } from "../redux/vehicles/actions";
import AppImages from "../assets/AppImages";

type FileUploadProps = {
    media: Media | null;
    name: string;
    desc: string;
    accept: string;
    title?: string;
    btnText?: string;
    gap?: string;
    titleClass?: string;
    iconClass?: string;
    iconBgClass?: string;
    btnClass?: string;
    Icon?:  string | React.FC<React.SVGProps<SVGSVGElement>>;
    isMultiple?: boolean;
    onFileChange?: (files: FileList) => void;
    onFileRemove?: (id: number) => void;
};

const FileUpload: React.FC<FileUploadProps> = ({
    media,
    name,
    desc,
    accept,
    title,
    titleClass,
    iconClass,
    btnText,
    gap,
    btnClass,
    iconBgClass,
    Icon,
    isMultiple,
    onFileChange,
    onFileRemove,
}) => {
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (onFileChange) {
            const files = event.target.files;
            onFileChange(files as FileList);
        }
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            const files = event.dataTransfer.files;
            if (onFileChange) {
                onFileChange(files);
            }
        }
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    return (
        <div className="h-full flex items-center">
            <div
                className={`group justify-center h-full items-center flex flex-col transition-all ${
                    gap ?? ""
                }`}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                onDragEnter={handleDragOver}
                onDragLeave={handleDragOver}
                onClick={(e: any) => {
                    e.currentTarget.parentElement?.querySelector(`#${name}`)?.click();
                }}
            >
                {media && media?.full_url ? (
                    <div className="relative w-full h-full">
                        <IconButton
                            isCircular
                            size="sm"
                            variant="ghost"
                            className="!absolute opacity-0 group-hover:opacity-100 top-2 right-2 z-10 bg-gray-400 text-white hover:bg-red-500"
                            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                e.stopPropagation();
                                if (onFileRemove) {
                                    onFileRemove(media.id);
                                }
                            }}
                        >
                            <AppImages.iconTrash className="w-4 h-4" />
                        </IconButton>

                        <div className="relative w-full h-full">
                            <img
                                src={media.full_url}
                                alt="File preview"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                ) : (
                    <React.Fragment>
                        <div className={`bg-secondary rounded-full p-3 ${iconBgClass ?? ""}`}>
                            {Icon ? (
                                typeof Icon === "string" ? (
                                    <img
                                        src={Icon}
                                        alt="File icon"
                                        className={`w-8 h-8 ${iconClass ?? ""}`}
                                    />
                                ) : (
                                    <Icon className={`w-8 h-8 ${iconClass ?? ""}`} />
                                )
                            ) : (
                                <AppImages.iconPhotograph
                                    className={`text-[#64748B] w-8 h-8 ${iconClass ?? ""}`}
                                />
                            )}
                        </div>
                        <Typography className={`block text-primary ${titleClass ?? ""}`}>
                            {title}
                        </Typography>
                        {desc && (
                            <Typography type="small" className="block text-foreground">
                                {desc}
                            </Typography>
                        )}
                        <Button
                            className={`flex w-max items-center gap-2 justify-center ${
                                btnClass ?? ""
                            }`}
                        >
                            {btnText ?? "Choose File"}
                            <Upload className="w-5 h-5" />
                        </Button>
                    </React.Fragment>
                )}
            </div>

            <input
                type="file"
                id={name}
                className="hidden"
                accept={accept}
                multiple={isMultiple ?? false}
                onChange={handleFileChange}
            />
        </div>
    );
};

export default FileUpload;
